export const VehicleContactRole = Object.freeze({
  DRIVER: 2 ** 0,
  OWNER: 2 ** 1,
  DISPATCHER: 2 ** 2,
});
